import { scrollTop } from '@/utils';
import { RefObject, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function useScrollToTop<T extends HTMLElement>() {
  const { pathname } = useLocation();

  const scrollToTop = (ref?: RefObject<T>) => {
    if (ref?.current) {
      ref.current.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (typeof window !== 'undefined' && window.scrollTo) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    scrollTop();
  }, [pathname]);

  return { scrollToTop };
}
